import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const isFromLeadFactory: TComputedPropMapper<boolean> = ({ offer: { newbuilding } }) =>
  Boolean(newbuilding && newbuilding.isFromLeadFactory);
